import React, { Component } from 'react';
import { faqDidMount } from '../helper';

class FaqCh extends Component {
    componentDidMount() {
        faqDidMount();
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="mgt-30 faq-container">
                        <div className="text-left">
                            <h2 className="common-title">TRIAM 常见问题</h2>
                        </div>
                        <div className="faq-content">
                            <div className="list-policy">
                                <div className="list-policy-item row">
                                    <ul className="list-policy-sidenav col-12 col-md-6">
                                        <li>
                                            <a href="#role-a"><b>A</b>创建账户</a>
                                            <ul>
                                                <li><a href="#role-a1"><b>A-1</b>如何注册创建账户？</a></li>
                                                <li><a href="#role-a2"><b>A-2</b>注册创建账户收费吗？</a></li>
                                                <li><a href="#role-a3"><b>A-3</b>在哪里可以查看电子邮件记载的验证码？</a></li>
                                                <li><a href="#role-a4"><b>A-4</b>本人身份确认、需要准备什么相关资料？</a></li>
                                                <li><a href="#role-a5"><b>A-5</b>任何国家均为合法注册创建帐户吗？</a></li>
                                                <li><a href="#role-a6"><b>A-6</b>邮件无法收取，也接收不到验证代码。</a></li>
                                                <li><a href="#role-a7"><b>A-7</b>未成年者可以注册创建账号吗?</a></li>
                                                <li><a href="#role-a8"><b>A-8</b>一人可以注册多个账号吗？</a></li>
                                                <li><a href="#role-a9"><b>A-9</b>可以注册创建公司账号吗？</a></li>
                                                <li><a href="#role-a10"><b>A-10</b>显示无效的验证代码，无法注册</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-b"><b>B</b>安全性</a>
                                            <ul>
                                                <li><a href="#role-b1"><b>B-1</b>忘记登录密码。</a></li>
                                                <li><a href="#role-b2"><b>B-2</b>密码输入错误，账户被冻结。</a></li>
                                                <li><a href="#role-b3"><b>B-3</b> 如何更改登录密码？</a></li>
                                                <li><a href="#role-b4"><b>B-4</b>输入后显示「该用户不存在」、「密码错误」无法登录账户。</a></li>
                                                <li><a href="#role-b5"><b>B-5</b>设置登录密码字符为几位数？</a></li>
                                                <li><a href="#role-b6"><b>B-6</b>什么是双重身份验证？</a></li>
                                                <li><a href="#role-b7"><b>B-7</b>什么是双重身份重置代码？</a></li>
                                                <li><a href="#role-b8"><b>B-8</b>如何解除双重身份重置代码？</a></li>
                                                <li><a href="#role-b9"><b>B-9</b>忘记双重身份重置代码。</a></li>
                                                <li><a href="#role-b10"><b>B-10</b>没有智能手机，可以设置双重身份验证吗？</a></li>
                                                <li><a href="#role-b11"><b>B-11</b>什么是交易密码？</a></li>
                                                <li><a href="#role-b12"><b>B-12</b>如果更改交易密码？</a></li>
                                                <li><a href="#role-b13"><b>B-13</b>忘记交易密码。</a></li>
                                                <li><a href="#role-b14"><b>B-14</b>设置交易密码字符为几位数以上？</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-c"><b>C</b>更改注册信息</a>
                                            <ul>
                                                <li><a href="#role-c1"><b>C-1</b>更改电子邮箱地址。</a></li>
                                                <li><a href="#role-c2"><b>C-2</b>更改已注册名称。</a></li>
                                                <li><a href="#role-c3"><b>C-3</b>如何查看自己的注册信息？</a></li>
                                                <li><a href="#role-c4"><b>C-4</b>如何置换国家语言？</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-d"><b>D</b>创建电子钱包</a>
                                            <ul>
                                                <li><a href="#role-d1"><b>D-1</b> 如何创建新的电子钱包？</a></li>
                                                <li><a href="#role-d2"><b>D-2</b>什么是电子钱包地址？</a></li>
                                                <li><a href="#role-d3"><b>D-3</b>什么是密钥？</a></li>
                                                <li><a href="#role-d4"><b>D-4</b>什么是Google（谷歌）双重身份验证？</a></li>
                                                <li><a href="#role-d5"><b>D-5</b>如何更改电子钱包地址？</a></li>
                                                <li><a href="#role-d6"><b>D-6</b>如何更改电子钱包名称？</a></li>
                                                <li><a href="#role-d7"><b>D-7</b>创建电子钱包收费吗？</a></li>
                                                <li><a href="#role-d8"><b>D-8</b>可以创建多个电子钱包吗？</a></li>
                                                <li><a href="#role-d9"><b>D-9</b>一个电子钱包可持有多少种代币？</a></li>
                                                <li><a href="#role-d10"><b>D-10</b>电子钱包的页面显示「＋」符号是什么意思？</a></li>
                                                <li><a href="#role-d11"><b>D-11</b>「电子钱包显示被封锁」如何操作？</a></li>
                                                <li><a href="#role-d12"><b>D-12</b>创建电子钱包时已按「保存」，如何让电子钱包生效？</a></li>
                                                <li><a href="#role-d13"><b>D-13</b>创建新电子钱包时，为何必须20RIA币以上？</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-f"><b>F</b>TRUST</a>
                                            <ul>
                                                <li><a href="#role-f1"><b>F-1</b>什么是TRUST?</a></li>
                                                <li><a href="#role-f2"><b>F-2</b>如何TRUST别的 货币·代币？</a></li>
                                                <li><a href="#role-f3"><b>F-3</b>如何解除已TRUST的 货币·代币？</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul className="list-policy-sidenav col-12 col-md-6">
                                        <li>
                                            <a href="#role-x"><b>X</b>手续费</a>
                                            <ul>
                                            <li><a href="#role-x1"><b>X-1</b>什么是交易费</a></li>
                                            <li><a href="#role-x2"><b>X-2</b>交易手续费如何收取？</a></li>
                                            <li><a href="#role-x3"><b>X-3</b>发送显示错误，代币发送未成功，为何扣除手续费？</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-g"><b>G</b>发送 货币·代币，接收 货币·代币</a>
                                            <ul>
                                                <li><a href="#role-g1"><b>G-1</b>如何向好友发送RIA币？</a></li>
                                                <li><a href="#role-g2"><b>G-2</b>发送 货币・代币的数量有限制吗？</a></li>
                                                <li><a href="#role-g3"><b>G-3</b>货币・代币发送后多长时间可显示？</a></li>
                                                <li><a href="#role-g4"><b>G-4</b>发送 货币・代币时，显示「发生错误，此电子钱包地址不存在」</a></li>
                                                <li><a href="#role-g5"><b>G-5</b>发送的 货币・代币已显示成功，接收方没有接收到？</a></li>
                                                <li><a href="#role-g6"><b>G-6</b>货币・代币 误发了错误的电子钱包，该如何操作？</a></li>
                                                <li><a href="#role-g7"><b>G-7</b>如何查看货币・代币是否发送成功？</a></li>
                                                <li><a href="#role-g8"><b>G-8</b>无法接收已TRUST的代币</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-h"><b>H</b>ISSUER</a>
                                            <ul>
                                                <li><a href="#role-h1"><b>H-1</b>什么是ISSUER?</a></li>
                                                <li><a href="#role-h2"><b>H-2</b>如何成为ISSUER?</a></li>
                                                <li><a href="#role-h3"><b>H-3</b>ISSUER从申请到批准需要几天的时间？</a></li>
                                                <li><a href="#role-h4"><b>H-4</b>申请ISSUER收费吗？</a></li>
                                                <li><a href="#role-h5"><b>H-5</b>ISSUER的申请，个人身份确认需要准备什么资料？</a></li>
                                                <li><a href="#role-h6"><b>H-6</b>如何递交个人身份身份确认资料？</a></li>
                                                <li><a href="#role-h7"><b>H-7</b>申请ISSUER是否可根据居住所在国家进行申请？</a></li>
                                                <li><a href="#role-h8"><b>H-8</b>申请ISSUER时需输入的「团体/公司」是什么？</a></li>
                                                <li><a href="#role-h9"><b>H-9</b>如何更改申请已注册的ISSUER资料？</a></li>
                                                <li><a href="#role-h10"><b>H-10</b>没有接收到申请ISSUER的受理邮件</a></li>                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-j"><b>J</b>创建・发行 代币</a>
                                            <ul>
                                                <li><a href="#role-j1"><b>J-1</b>如何创建代币。</a></li>
                                                <li><a href="#role-j2"><b>J-2</b>创建代币时显示的「属性」是什么？</a></li>
                                                <li><a href="#role-j3"><b>J-3</b>创建代币或发行代币收费吗？</a></li>
                                                <li><a href="#role-j4"><b>J-4</b>请用易理解的方式说明如何使用RIA的比率。</a></li>
                                                <li><a href="#role-j5"><b>J-5</b>代币申请的状态显示“待定”无法创建代币。</a></li>
                                                <li><a href="#role-j6"><b>J-6</b>已创建的代币可以删除吗？</a></li>
                                                <li><a href="#role-j7"><b>J-7</b>代币的添加发行已无效。可以恢复吗？</a></li>
                                                <li><a href="#role-j8"><b>J-8</b>电子钱包有余额，却一直显示「Not enough funds in source account」无法发行代币。</a></li>
                                                <li><a href="#role-j9"><b>J-9</b>当接收到用户的Trust的申请时，如果被拒绝将显示什么样的图标？</a></li>
                                                <li><a href="#role-j10"><b>J-10</b>无法使用指定的代币名称创建。</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-k"><b>K</b>其它</a>
                                            <ul>
                                                <li><a href="#role-k1"><b>K-1</b>关于推荐的浏览器</a></li>
                                                <li><a href="#role-k2"><b>K-2</b>什么是代币？</a></li>
                                                <li><a href="#role-k3"><b>K-3</b>删除多余的电子钱包。</a></li>
                                                <li><a href="#role-k4"><b>K-4</b>可以保存一个作为频繁发送代币的地址吗？</a></li>
                                                <li><a href="#role-k5"><b>K-5</b>电子钱包合并是一项是什么样的功能？</a></li>
                                                <li><a href="#role-k6"><b>K-6</b>个人身份确认的图片超过2MB，无法上传，如何操作？</a></li>
                                                <li><a href="#role-k7"><b>K-7</b>关于电子钱包交易记录查询</a></li>
                                                <li><a href="#role-k8"><b>K-8</b> 设置页面显示的「登录时请输入双重身份验证码 」要求，是什么意思？</a></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <a href="#role-m"><b>M</b>Multisig 电子钱包</a>
                                            <ul>
                                                <li><a href="#role-m1"><b>M-1</b>什么是Multisig 电子钱包？</a></li>
                                                <li><a href="#role-m2"><b>M-2</b>创建Multisig 电子钱包收费吗？</a></li>
                                                <li><a href="#role-m3"><b>M-3</b>创建Multisig 电子钱包步骤如何操作？</a></li>
                                                <li><a href="#role-m4"><b>M-4</b>Multisig 电子钱包发送代币的步骤如何操作？</a></li>
                                                <li><a href="#role-m5"><b>M-5</b>Multisig创建时下载的密钥确认后，密钥显示为6个，哪个才是密钥？</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="container-role" id="accordion" role="main">
                                <div className="r-role-legend">
                                    <p>感谢您使用TRIAM Network</p>
                                    <p>如果您在使用TRIAM时遇到不明问题，请参阅以下Q&A问题。</p>
                                    <p>TRIAM Network提供各种支持，让您更放心方便的使用。</p>
                                </div>

                                <div className="panel-group" id="accordion">
                                    <div className="r-role-item" id="role-a">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>A</strong>创建账户</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-a1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a1" className="panel-title expand custom-h3-font-size custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-1</strong>如何注册创建账户？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>注册创建TRIAM Network账户，任何电子邮箱地址均可进行注册账户。注册账户只需要一个电子邮箱地址与您设定的登录密码既可注册账户。</p>
                                                    <p>1. 请前往登录页面、点击打开创建账户、输入姓名、电子邮箱地址和登录密码。</p>
                                                    <p>2. 双击「下一步」按钮、接收自动回复邮件。</p>
                                                    <p>3. 输入自动回复邮件中的显示的验证码即完成账户创建</p>
                                                    <p>4. 设置双重身份验证和交易密码后，即可创建电子钱包。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-2</strong>注册创建账户收费吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>注册创建账户是免费的。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-3</strong>在哪里可以查看电子邮件记载的验证码？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>创建账户时，您注册的电子邮箱会接收到由TRIAM Network发出的「邮件验证代码」标题的邮件，该邮件中记载着验证代码。</p>
                                                    <p>指定页面中输入接收到的验证代码，创建账户即可进行下一步。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-4</strong>个人身份确认、需要准备什么相关资料？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>创建账户，无需提交个人身份确认资料。</p>
                                                    <p>申请Issuer时必须提交个人身份相关确认资料</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-5</strong>任何国家均为合法注册创建帐户吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>有关注册账户以及货币使用者，请在所在国家的・地区法律・法则及法规的遵从下使用</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-6</strong>邮件无法收取，也接收不到验证代码。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>未能收到邮件的用户、可能存在以下几种情况造成、很抱歉，请您确认以下内容。</p>
                                                    <p>■电子邮件可能自动被分类于垃圾邮件中。</p>
                                                    <p>垃圾邮件的防护功能有可能将TRIAM Network的邮件误认为垃圾邮件等情况。</p>
                                                    <p>有可能被自动分类于垃圾文件夹中或垃圾箱，请您再次确认邮箱。</p>
                                                    <br />
                                                    <p>■使用移动电话・智能手机的电子邮箱地址的用户</p>
                                                    <p>有可能被防打扰邮件滤器截止</p>
                                                    <p>开启防邮件打扰功能的用户，请发送邮件至 [no-reply@triazamnetwork.com]重新设置为可接收邮件信息。</p>
                                                    <br />
                                                    <p>■电子邮箱地址错误</p>
                                                    <p>也有可能注册填写电子邮箱地址时，字母/数字/或上下横线的有错误的可能性。</p>
                                                    <br />
                                                    <p>■输入的电子邮箱地址错误</p>
                                                    <p>用户在注册时 输入了错误的电子邮箱地址类似的错误事例很多。</p>
                                                    <br/>
                                                    <p>■防病毒软件、安全软件的设置</p>
                                                    <p>设置的安全软件，将会把邮件判断为垃圾邮件而被拒绝接收也有可能被删除的可能性。</p>
                                                    <p>检查目前使用中设置的安全软件，请将设置垃圾邮件为排除外。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-7</strong>未成年者可以注册创建账号吗?</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>有关未成年创建账户以及代币使用者，使用者必须遵从、遵守当地的法律，法规下使用。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-8</strong>一人可以注册多个账号吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>注册账户数量无限制。只要电子邮箱地址不重复可创建多个账户。但是，创建多 个账户的用户者，请务必妥善管理</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a9">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a9" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-9</strong>可以注册创建公司账号吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a9" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>目前、电子钱包不区分与个人或公司。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-a10">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-a10" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>A-10</strong>显示无效的验证代码，无法注册</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-a10" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>自动回复的邮件中记载的验证代码有时间限制的、接收邮件后30分钟内则自动失效。</p>
                                                    <p>重发代码，必须已接收的验证代码失效后，也就是30分钟后才可以重发</p>
                                                    <p>如果出现失效代码和显示错误，请再次返回到注册创建账号页面，重新注册并重发送验证码。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-b">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>B</strong>安全性</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-b1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-1</strong>忘记登录密码。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>如果您忘记了密码，请到登录页面中点击【忘记密码，请点击此处】进行设置。重置密码时必须输入您注册时填写的电子邮箱地址。</p>
                                                    <br />
                                                    <p>①	　忘记密码，请点击此处</p>
                                                    <p>②	　请输入注册时的电子邮箱地址 </p>
                                                    <p>③	　重置验证码已发送到您的邮箱</p>
                                                    <p>④	　请输入您收到的验证码</p>
                                                    <p>⑤	　请输入新密码</p>
                                                    <br />
                                                    <p className="red" style={{ color: 'red'}}>
                                                        *削除してください
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-2</strong> 密码输入错误，账户被冻结。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>输入密码在一定次数范围内，账户登录时间会被限制。如果连续输入错误密码次 数过多，安全软件将自动开启保护，账号将自动被冻结。如果账号被冻结，请您 通过电子邮件发送到以下邮箱地址与我们联系。</p>
                                                    <p>TRIAM Support Team</p>
                                                    <p><a>support@triamnetwork.com</a></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-3</strong>如何更改登录密码？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>登录密码的更改 请从设置页面点击[更改登录密码]或者从登录页面中点击【忘记密码】后进行重置密码。<br /></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-4</strong>输入后显示「该用户不存在」、「密码错误」无法登录账户。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>输入登录密码时会自动区分大小写文字。<br />如果无法登录账号时，请确认大小写键盘是否有打开、确认您的密码文字字母是否输入有误。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-5</strong>设置登录密码字符为几位数？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>为了您账户的安全，TRIAM Network网络需要设置一个强大的密码。密码设置必 须6个文字以上、100个文字以内字。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-6</strong>什么是双重身份验证？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>双重验证是指，除了TRIAM Network登录密码以外，加上代码进行验证，加强账号的安全性。<br />TRIAM Network可以利用Google（谷歌）的验证应用程序进行双重验证的设置</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-7</strong>什么是双重身份验证重置代码？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>双重身份验证重置代码是指，设置双重身份验证更改手机端末等需要的代码<br />
                                                    手机丢失，故障或机种更换时等都必须使用到双重身份重置代码。<br /><br /></p>
                                                    <p className="red">！！！请注意！！！<br />
                                                    由于双重身份重置代码在设置时仅显示一次，无法再次显示和无法再发行。请务必保存好切勿丢失。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-8</strong>双重身份验证可以解除吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>登录后，通过设置页面菜单可进行重置和更改。</p>
                                                    <p>重置必须设置时发行的重置代码。从安全角度出发，TRIAM Network中，使用双重身份验证服务时必备项目。可进行更改设置，但如果一旦解除双重身份验证TRIAM Network内的各种功能将不能使用。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b9">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b9" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-9</strong>忘记双重身份验证的重置代码。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b9" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>双重身份验证代码在设置时仅显示一次，一旦丢失，无法再显示也无法再次发行。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b10">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b10" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-10</strong>没有智能手机，可以设置双重身份验证吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b10" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>TRIAM Network的双重身份验证使用由Google(谷歌）提供的服务。有WEB版本，IOS版本，安卓版本。请根据您的设备进行选择版本。<br />有关Google（谷歌）双重身份验证请参阅以下链接<br /><a target="_blank" rel="noopener noreferrer" href="https://www.google.com/landing/2step/">https://www.google.com/landing/2step/</a></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b11">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b11" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-11</strong>什么是交易密码？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b11" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>交易密码是发送代币等各种实时交易时输入的密码。</p>
                                                    <p>
                                                    ・必须含1个数字以上
                                                    ・必须含1个符号以上
                                                    ・必须含1个小字母以上
                                                    ・必须含1个大字母以上
                                                    </p><br/><br/>
                                                    <p className="red">！！！请注意！！！</p>
                                                    <p>
                                                        交易密码忘记或丢失虽然可以进行重置密码，如果交易密码一旦重置操作，安全系统将自动开启，账户内的所有的电子钱包将自动封锁。<br/>
                                                        解除电子钱包封锁，必须使用各电子钱包的密钥才能解锁。<br/>
                                                        在重置交易密码前，务必检查是否持有各电子钱包的密钥后再进行重置交易密码。<br/>
                                                        如果没有密钥，无法解锁的情况，电子钱包将永远被冻结，无法使用。<br/>

                                                        <a href="https://triamnetwork.com/faq#role-d12">解锁电子钱包方法请点击→</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b12">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b12" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-12</strong>如果更改交易密码？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b12" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        从设置页面点击 [更改交易密码] 可进行更改。<br/>
                                                        首先，输入您当前使用的交易密码，再输入您想更改的新密码后点击更改按键即可。<br/>
                                                        确认以下规则后，使用6位数以上的英文大小写字母和符号进行设置交易密码 <br/>
                                                    </p>
                                                    <p>
                                                        ・必须含1个数字以上<br/>
                                                        ・必须含1个符号以上<br/>
                                                        ・必须含1个小字母以上<br/>
                                                        ・必须含1个大字母以上<br/>
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b13">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b13" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-13</strong>忘记交易密码。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b13" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                <p>
                                                        交易密码忘记或丢失虽然可以进行重置密码，如果交易密码一旦重置操作，安全系统将自动开启，账户内的所有的电子钱包将自动封锁。<br/>
                                                        解除电子钱包封锁，必须使用各电子钱包的密钥才能解锁。<br/>
                                                        在重置交易密码前，务必检查是否持有各电子钱包的密钥后再进行重置交易密码。<br/>
                                                        如果没有密钥，无法解锁的情况，电子钱包将永远被冻结，无法使用。<br/>
                                                        交易密码重置顺序。<br/>

                                                        ①点击设置页面中的[重置交易密码]。<br/>
                                                        ②输入更改的新密码。<br/>
                                                        
                                                    </p>
                                                    <p>
                                                        ※确认以下规则后，使用6位数以上的英文大小写字母和符号进行设置交易密码。<br/>

                                                        ・必须含1个数字以上<br/>
                                                        ・必须含1个符号以上<br/>
                                                        ・必须含1个小字母以上<br/>
                                                        ・必须含1个大字母以上<br/>
                                                    </p>
                                                    <p>
                                                        ③下一步，请选择账户中其中一个电子钱包，输入电子钱包的密码后点击[重置交易密码] 。<br/>
                                                        ④交易密码一旦重置，将封锁您账户中所有的电子钱包，您可以在最后一步中解除各电子钱包。
                                                    </p>
                                                    <p>
                                                        请选择须解除的电子钱包后输入电子钱包密钥后点击 [解除] 按键。<br/>
                                                        最后点击[完成] 按键结束。<br/>
                                                        ※解除电子钱包最后或过后也可进行解除。<br/>
                                                        
                                                        <a href="https://triamnetwork.com/faq#role-d12">解除电子钱包封锁请点击→</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-b14">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-b14" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>B-14</strong>设置交易密码字符为几位数以上？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-b14" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                <p>※确认以下规则后，使用6位数以上的英文大小写字母和符号进行设置交易密码。<br/>
                                                        ・必须含1个数字以上 <br/>
                                                        ・必须含1个符号以上 <br/>
                                                        ・必须含1个小字母以上 <br/>
                                                        ・必须含1个大字母以上
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-c">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>C</strong>更改注册信息</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-c1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-c1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>C-1</strong>如何更改电子邮箱地址。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-c1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>由于您注册TRIAM Network时电子邮箱作为登录ID使用，因此无法更改。如果您 注册的电子邮箱地址无法使用，请您联系我们的客服帮助。</p>
                                                    <br />
                                                    <p><a>support@triamnetwork.com</a></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-c2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-c2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>C-2</strong>更改已注册名称。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-c2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>希望更改注册信息的用户请发邮件与我们的客服帮助联系。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-c3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-c3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>C-3</strong>如何查看自己的注册信息？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-c3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>很抱歉给您带来不便，请发送邮件至客户帮助联系。</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-c4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-c4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>C-4</strong>C-4 如何置换国家语言？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-c4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>您可以通过屏幕上右上角显示的国旗标志进行更改国家语言。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-d">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>D</strong>创建电子钱包</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-d1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-1</strong>如何创建新的电子钱包？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        从我的电子钱包页面点击「创建新钱包」进行操作。<br />
                                                        电子钱包名称可随意设置和更改。这个时候会显示密钥，请务必妥善保管。<br />
                                                        创建电子钱包，需要从其它的电子钱包提供必要的资金。请在「发送RIA币」 前面✔，同时请指定提供初期资金的电子钱包。接着请输入初期资金的数量， 初期资金必须20RIA币以上。<br />
                                                        所有项目输入后请点击「创建」后，系统将提醒要求输入双重身份验证代码，请 您输入Google（谷歌）生成的动态验证代码。<br/>
                                                        <br />

                                                        ■初次创建电子钱包的顺序<br />
                                                        账户内第一次创建电子钱包的，必须从其它的电子钱包提供初期资金。<br />
                                                        1) 点击我的电子钱包页面中的「创建电子钱包」<br />
                                                        2) 随意输入电子钱包名称<br />
                                                        3) 保存密钥<br />
                                                        4) 点击「保存」<br />
                                                        电子钱包保存后，请求提供初期资金的用户者对电子钱包进行激活操作。<br />
                                                        操作激活的用户，从自己账户中、我的电子钱包页面点击「激活电子钱包」。<br />
                                                        输入需要激活的电子钱包地址。<br />
                                                        此时，不用选中打勾「激活电子钱包」复选框继续执行操作。<br />
                                                        选择提供初期资金的电子钱包，输入由Google（谷歌）显示的双重身份验证代码即完成！<br /><br />
                                                    </p>
                                                    <p className="red">!!! 请注意 !!!<br />
                                                        创建电子钱包时所显示的密钥十分重要，在更改密码或恢复账户时必须用到。<br />
                                                        密钥仅在创建电子钱包时显示一次，请务必书写或印刷或拍照的方式或当前离线状态保存。<br />
                                                        每个电子钱包发行的密钥各不相同。<br />
                                                        如果密钥一旦被泄露第三者，电子钱包存在被盗取的可能，请务必保存好密钥。<br /></p>


                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-2</strong>什么是电子钱包地址？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                <p>电子钱包地址指的是，在TRIAM Network中使用的货币或代币发送接收需用到，
                                                类似于银行的账号一样的。电子钱包地址是由27～34个英文字母，数字组织而
                                                成的。每创建一个电子钱包仅发行一个电子钱包地址。当您需要接收货币或代币
                                                ，发送货币或代币，或者发行代币时就必须用到电子钱包地址。<br/>
                                                电子钱包地址用于通知他人发送货币或代币的地址，第三方知晓也不会泄露个人信息。<br/>
                                                已创建的电子钱包地址无法更改。已创建的电子钱包地址可从「我的电子钱包」页面进行确认。
                                                </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-3</strong>什么是密钥？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        密钥是每个创建的钱包发行的代码。<br />
                                                        密钥是电子钱包进行解锁，修复和导入用的重要代码。<br />
                                                        泄露密钥就等于泄露银行卡的密码一样。一旦丢失或泄露密钥，则无法再进行恢 复电子钱包操作，有问题也无法处理的风险。请务必保存好密钥，密钥可令出现 问题的电子钱包进行修复和处理电子钱包的各种问题。<br /><br />

                                                        密钥仅在创建电子钱包时显示一次，由于无法再次显示和再发行，请您务必要保存好。<br />

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-4</strong>什么是Google（谷歌）双重身份验证？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    双重身份验证是指除了需要输入登录密码外，还须输入Google手机端末显示的代码的一种安全流程。为了登录和执行交易增加有必要的信息，即使遭到网络暴力攻击而被盗取密码也无法直接登录或直接交易。<br />
                                                        <a target="_blank" rel="noopener noreferrer" href="https://www.google.co.jp/intl/ja/landing/2step/">https://www.google.co.jp/intl/ja/landing/2step/</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-5</strong>如何更改电子钱包地址？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    已创建的电子钱包地址无法进行更改。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-6</strong>如何更改电子钱包名称？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    从「我的电子钱包」页面，选择需要更改的名称的电子钱包，电子钱包更改次数 无限制，请点击电子钱包名称右边显示的铅笔符号进行更改。<br/>
                                                    此外，电子钱包名称功能为了自己更方便管理，发送或接收的业务无需告知对方 电子钱包名称。

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-7</strong>创建电子钱包需要费用吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    创建电子钱包自身是免费的、使用电子钱包进行（保存RIA币，发送/接收代币、货币）等服务。必须激活电子钱包，激活电子钱 包必须持有20RIA以上。<br />
                                                    请注意用于激活电子钱包的20RIA币为电子钱包最低数量，无法挪动也无法使用。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-8</strong>可以创建多个电子钱包吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    创建电子钱包数量无限制，但每个电子钱包必须持有20RIA币以上才能使用电子 钱包功能。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d9">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d9" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-9</strong>一个电子钱包可持有多少种代币？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d9" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    使用代币操作前必须先TRUST代币。电子钱包对保存货币、代币的种类和货币、代币的数量均无限制。

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d10">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d10" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-10</strong>电子钱包的页面显示「＋」符号是什么意思？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d10" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    点击「+」符号，您可以进行TRUST代币，也可以通过搜索进行TRUST其它代币。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d11">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d11" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-11</strong>「电子钱包显示被封锁」如何操作？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d11" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        密码一旦更改。各电子钱包安全功能将自动开启，封锁所有电子钱包。<br />
                                                        解除电子钱包封锁，需要使用各电子钱包的密钥进行解锁。<br />
                                                        从「我的电子钱包」页面，点击电子钱包左边显示的「小锁头」符号<br />
                                                        请在所显示页面输入正确的密钥，电子钱包将自动解锁。<br/>
                                                        每个电子钱包持有的密钥各不相同，必须输入相对应的密钥进行解锁。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d12">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d12" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-12</strong>创建电子钱包时已按「保存」，如何让电子钱包生效？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d12" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        电子钱包创建后直接保存，该电子钱包为未激活状态。<br />
                                                        需要使用已激活的电子钱包发送20RIA币以上进行激活待激活的电子钱包。<br/>
                                                        从我的电子钱包页面中、点击电子钱包左边显示的「！」符号。<br />
                                                        选择提供初期电子钱包、激活电子钱包需要20RIA币以上、输入初期数量。最后输入Google显示的双重身份验证代码，电子钱包将激活。<br /><br />

                                                        从其它的账户电子钱包中提供初期资金的用户，请提供初期资金的账户持有者进行激活电子钱包 <br/>
                                                        我的电子钱包页面点击「激活电子钱包」<br />
                                                        输入想要激活的电子钱包地址。<br />
                                                        这个时候，「激活电子钱包」旁边的方框无需打勾直接继续操作。<br />
                                                        选择提供初期资金的电子钱包、输入Google双重身份验证代码后完成。<br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-d13">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-d13" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>D-13</strong>创建新电子钱包时，为何必须20RIA币以上？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-d13" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    由于空电子钱包会自动被识别为无效电子钱包，因此创建新电子钱包时必须持有RIA币。<br/>
                                                    TRIAM电子钱包，最低必须20RIA币才能有效激活。<br/>
                                                    最低的余量有助于网络保护和防止创建垃圾邮箱。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-f">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>F</strong>TRUST</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-f1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-f1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>F-1</strong>什么是TRUST?</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-f1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        TRUST简单的说明「信赖货币或信赖代币」的意思。<br />
                                                        在诸多代币中，它是一种仅启用您经过判断和可信赖的代币进行TRUST的功能。<br/>
                                                        使用发送代币·接收代币前，必须先TRUST代币。<br />

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-f2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-f2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>F-2</strong>如何TRUST别的 货币·代币？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-f2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        从我的电子钱包页面，点击「+」号会显示可TRUST的代币。<br />

                                                        想TRUST的代币不显示可进行手动输入进行搜索。点击想TRUST的代币后再点 击TRUST键即添加成功。 <br />
                                                        

                                                        TRUST代币分为两种，直接申请即批准和必须通过ISSUER者批准。<br />

                                                        电子钱包页面已添加的代币右下角显示打勾符号即表示已经添加完成状态。如果电子钱包页面已添加的代币的右下角显示时钟的符号即表示ISSUER 者未批准状态。<br/>
                                                        如果TRUST处于未批准状态，该代币则无法使用与发送。

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-f3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-f3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>F-3</strong> 如何解除已TRUST的 货币·代币？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-f3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    想解除已TRUST的代币，必须持有的代币数量为0才可解除。<br/>
                                                    点击电子钱包内想解除TRUST的代币，接着点击「解除TRUST」继续操作。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-x">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>X</strong>手续费</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-x1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-x1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>X-1</strong>什么是交易费</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-x1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        处理区块链信息时产生的手续费。<br />
                                                        另外，即使交易失败也产生手续费。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-x2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-x2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>X-2</strong>交易手续费如何收取？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-x2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        RIA币一次交易手续费为0.001RIA币。<br /><br />

                                                        TRIAM平台上创建的代币需要发送时，将产生RIA币交易手续费和代币交易 手续费以上两笔手续费。代币的交易手续费因代币种类而异。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-x3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-x3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>X-3</strong>发送显示错误，代币发送未成功，为何扣除手续费？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-x3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    由于区块链上信息需要做处理，即使发送货币或代币时发生错误或失败，也会产 生一定交易费。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-g">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>G</strong>发送 货币·代币，接收 货币·代币</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-g1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-1</strong> 如何向好友发送RIA币？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        从我的电子钱包页面开始，选择需要进行发送货币·代币的电子钱包.<br />
                                                        接着选择您需要发送的货币·代币。请点击RIA币·<br />
                                                        点击交易页面中显示的「发送货币·代币」·<br />
                                                        输入接收方的电子钱包地址和数量·<br />
                                                        最后输入Google（谷歌）显示的双重验证代码后完成。

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-2</strong>发送 货币・代币的数量有限制吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        货币·代币的发送数量无限制。<br />
                                                        发送时请注意，发送后的电子钱包最低的余量必须时20RIA以上· <br />
                                                        如果发送的余量不足20RIA,测会出现交易错误的显示·<br />
                                                        例如：电子钱包内持有总数量为50RIA币·<br />
                                                        减去激活使用的20RIA币和交易费的0.001RIA，剩余可发送的数量为29.999RIA 币·发送前请检查电子钱包余量是否足够<br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-3</strong>货币・代币发送后多长时间才显示？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    TRIAM Network上电子钱包之间的传送只需11秒～2秒将显示。交易处理较为繁 忙时、也有稍微延迟的可能。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-4</strong>发送 货币・代币时，发生错误、显示「此电子钱包地址不存在」。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        有可能接收方的电子钱包地址输入错误，又或者地址钱包地址被删除等无法得 到确认。<br />
                                                        如果显示「电子钱包地址不存在」的情况，请确认是否以下状况<br />
                                                        ・请再次确认发送方的电子钱包地址。<br />
                                                        ・请打开电子钱包交易记录，查看输入接收方的电子钱包地址是否正确。<br />
                                                        ・请与接收方确认接收方电子钱包是否被封锁状态。<br />
                                                        ・请与接收方确认电子钱包是否处于未激活状态。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-5</strong>发送的 货币・代币已显示成功，接收方没有接收到？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    如果发送的货币·代币已显示成功，但接收方并未接收到的情况，请参照以下并 确认。<br />
                                                        ・请再次确认接收方的电子钱包地址。<br />
                                                        ・请打开电子钱包交易记录，查看输入的电子邮箱地址是否正确。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-6</strong>将 货币・代币 误发了错误的电子钱包地址，该如何操作？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    很抱歉，一旦发送成功并处理完毕货币·代币，无法取消。即使您联系客服支持也 无法取消发送或恢复等相应操作。发送前务必确认是否有误再进行发送。

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-7</strong>如何查看货币・代币是否发送成功？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        电子钱包的交易记录中可以确认各电子钱包的交易状况。<br/>
                                                        也可以在使用扫描的方式在TRIAM Blockscan进行确认。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-g8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-g8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>G-8</strong>无法接收已TRUST的代币</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-g8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        TRUST代币分为两种，直接申请即批准和必须通过ISSUER者批准。<br/>
                                                        电子钱包内添加的代币的右下角如果显示打勾的符号即表示已 TRUST. <br/>
                                                        电子钱包你添加的代币的右下角如果显示时钟符号即则表示ISSUER者尚未批准 <br/>
                                                        如果TRUST尚未批准状态，该代币无法进行接收或发送的操作。<br/>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-h">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>H</strong>ISSUER者</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-h1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-1</strong>什么是ISSUER者?</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        成为ISSUER者、将有权独立创建代币，ISSUER代币。<br />
                                                        独立创建的代币可以广泛的使用于各种商务业务。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-2</strong>如何成为ISSUER者?</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        需要申请才能成为发行者。<br />
                                                        从设置页面「普通」进行申请。<br />
                                                        请输入必要事项和上传有效身份症附带头像页面先相片。<br />
                                                        身份证件仅限于各国机关发行的有效证件：<br />
                                                        例:机动车驾驶证，护照<br />
                                                        使用机动车驾驶证上传:必须提交车证的正面反面清晰照。<br />
                                                        使用护照上传：必须提交带头像，住所等记载页面清晰。<br />
                                                        请注意，如相片出现剪角、残缺或模糊则无法接收与确认。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-3</strong> ISSUER者从申请到批准需要几天的时间？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    按照提交的顺序对申请者的证件进行审核与验证，请提交者耐心的等待我 们结果， ISSUER者的申请审核通知将直接发送至申请者的注册邮箱。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-4</strong>申请ISSUER需要收费吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>ISSUER者的申请以及成为ISSUER者都无需费用</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-5</strong>ISSUER的申请，个人身份确认需要准备什么资料？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        ISSUER者的申请，须提交的本认确认资料，仅限于各国由国家发行的有效证件为准。<br />
                                                        居住在日本国内身份确认资料例子：（日本籍、外国籍）的用户、机动驾驶证、 护照或(日本发行护照）、个人号码卡、在留卡、特别永驻证明书或永驻卡。<br />
                                                        ※如个人号码卡（无照片的通知卡）不给予确认与受理。 <br /><br />
                                                        ■机动驾驶证<br />
                                                        ・正面，背面务必提交。<br />
                                                        ・请确认上传资料是否清晰可见。<br />
                                                        ・请确认地址，姓名，出生年月日是否清晰可见。确认上传的相片显示的地址，姓名，出生年月日与本人注册所填写内容是否一致。<br />
                                                        ・请确认证件是否为效期内。。<br />
                                                        ・请确认证件号码是否清晰可见。<br />
                                                        ・请确认公安部门印章是否清晰可见。若背面也有内容，确认背面的公安部印章 是否清晰。<br />
                                                        ・请确拍摄的相片、脸部是否清晰可见。<br /><br />

                                                        ■护照或（日本国家发行的护照）  <br />
                                                        ・请提交带头像的照片页面和持有填写栏页面（记载地址页面）共两页。<br />
                                                        ・请确认拍摄的资料证明是否全面、清晰可见。 <br />
                                                        ・请确认护照号码显示是否清晰可见。<br />
                                                        ・请确认证件是否为效期内。<br />
                                                        ・请确认地址，姓名，出生年月日是否清晰可见。确认上传的相片显示的地址、姓名，出生年月日与本人注册所填写内容是否一致。<br /><br />
                                                        ■个人号码卡 、个人号码通知卡（无个人头像）无法作为个人确认资料提交 ・提交个人号码卡/通知卡仅需要提交卡的正面。背面无需提交。
                                                        ・请确认拍摄的资料证明是否全面、清晰可见。 <br />
                                                        ・请确认证件是否为效期内。<br />
                                                        ・请确认地址，姓名，出生年月日是否清晰可见。确认上传的相片显示的地址，姓名，出生年月日与本人注册所填写内容是否一致。<br /><br />

                                                        ■在留卡和特别永驻证明书或永驻卡<br />
                                                        ・正面，背面也请务必提交。<br />
                                                        ・请确认拍摄的资料证明是否全面、清晰可见。 <br />
                                                        ・请确认地址，姓名，出生年月日是否清晰可见。确认上传的相片显示的地址、姓名，出生年月日与本人注册所填写内容是否一致。<br />
                                                        ・请确认卡号码显示是否清晰可见。<br />
                                                        ・请确认证件是否为效期内。<br />
                                                        ・请确认外管局印章是否清晰可见。若背面也有内容，确认背面的印章是否清晰。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-6</strong> 如何递交个人身份身份确认资料？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    可以从账户设置页面显示ISSUER者的申请和同时提交个人资料的确认和信息。请上传身份确认书并提交。<br />
                                                    相片的规格最大为2MB。<br />
                                                    有关提交相片注意点，请参照H-5。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-7</strong>申请ISSUER者是否可根据居住所在国家进行申请？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        居住国无限制、居住于任何国家都可以进行申请ISSUER者<br />
                                                        但是、有关发行货币·代币的使用者，请务必遵守国家及地区相关的法律法规。今后、如果全球或居住国发生相关法律法规的更改，已被验证的ISSUER者授权有可能随着法律法规更改而无效。<br />
                                                        请注意，如果发生以上情况，有关已发行的货币·代币 一旦产生了损害或损失等，我们不承担任何责任及不进行任何赔损和赔偿。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-8</strong>申请ISSUER者时需要输入的「团体/公司」是什么？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    如果ISSUER者由团体·公司执行，请输入注明。ISSUER者信息可选择公开或不公开。为了UER的代币更容易得到信赖，我们建议您设置为公开模式。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h9">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h9" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-9</strong>我想更改发行者申请时注册时的信息。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h9" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        如何更改申请已注册的ISSUER者信息？
                                                        从“设置”页面⇒点击“普通”页面中右下角显示的编辑发行者的信息后进行申请。重新编辑新信息之前，现有的信息持续有效。 输入新信息并获得批准后，现有的信息将无效并自动被删除后，显示为最新申请信息。<br/>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-h10">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-h10" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>H-10</strong>没有接收到申请ISSUER的受理邮件</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-h10" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        <a href="#role-a6"><b>请参照A-6</b></a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-j">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>J</strong>创建代币・发行</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-j1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-1</strong> 如何创建代币・发行代币。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        创建代币和发送代币，需要先申请发行者且通过批准。<br />
                                                        作为发行者且已通过批准的用户、从「发行者模式」页面中，可进行创建，发行。<br />
                                                        首先从「创建代币」中进行创建代币。<br />
                                                        选择创建代币的电子钱包。由于创建代币须使用RIA币，我们推荐您选择持有足够RIA币的电子钱包。<br />
                                                        下一步，选择代币的属性并设置代币的图标相图片。图标图片也可以稍后再设定。<br />
                                                        请输入代币名称，代币的小数点位数，交易手续费，RIA币的比率、最后，请选择此代币被使用后产生的手续费接收的电子钱包。<br />
                                                        以上完成创建代币。下一步，请继续代币的分发，代币的实际使用的操作。<br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-2</strong>创建代币时的属性是什么？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        根据属性的设置，您可以对其它用户如何使用您发行的代币设置某些限制。<br />
                                                        设置属性仅限一次，无法更改。<br />
                                                        属性1，可以对其它用户的TRUST申请做出允许或拒绝的授权。<br />
                                                        属性2，无法授权，用户对您发行的代币可以自由的进行TRUST和自由的使用。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-3</strong>创建代币，发行代币需要收费吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    创建代币无需任何费用，按发布已创建代币时可能需要RIA币，具体取决于该代币设置的RIA币的比率。<br />
                                                    再者，创建代币，发行代币，必须持有两个已激活并且各持有21RIA币以上的电子钱包。<br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-4</strong>与RIA的比率指的是什么？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    创建代币时，可以进行设置代币和RIA的比率。<br />
                                                    RIA的比率为，［无比率］［1/1］［1/10］［1/100］［1/1000］可5种选择。<br />
                                                    例如选择［1/1］发行「１代币」需要「1RIA币」。选择［1/1000］发行「１代币」需要「0.001RIA」币
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-5</strong>申请代币的记录状态一直显示「Pending」，无法创建代币。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    申请发行者或申请发行代币的批准处于保留中状态。<br />
                                                    申请发行代币所提交的本人确认资料按提交的顺序进行审核和批准，申请后请耐心的等待。<br />
                                                    发行者的申请验证完毕后。审查验证结果通知将发送至您注册的电子邮箱地址。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-6</strong>以创建的代币可以删除吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    已创建的代币，以及发行的代币无法删除。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-7</strong>代币的添加发行设置为禁用，可以再恢复吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    如果代币的添加发行设置为禁用，无法重新操作，也无法解除添加发行禁用。<br />
                                                    如果代币的添加发行设置为禁用，创建该代币的电子钱包所有的功能将被冻结。<br />
                                                    更改电子钱包设置，RIA币/代币的发送和接收，代币的添加发行・TRUST・解除RUST的功能将无法使用。<br/>
                                                    唯一可以使用功能是代币的TRUST允许权限。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-8</strong>显示「Not enough funds in source account」代币无法发送。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    请确认创建代币的电子钱包。<br />
                                                    根据创建代币时设置的RIA比率的基准，必须持有发行代币需要的RIAB币和交易手续费的RIA币。<br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j9">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j9" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-9</strong>对于接收到申请TRUST的用户做出拒绝申请，对方会显示什么样状态？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j9" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    拒绝对方申请TRUST的用户，对方的状态一直处于未批准状态，对方不会知道的功能。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-j10">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-j10" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>J-10</strong>可以使用自己希望的代币名称创建代币吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-j10" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    要创建的代币名称，不能与已发行代币的名称重复<br />
                                                    希望的代币名称存在被其它用户使用的可能性，创建代币前，建议提前想好代币名称的候补。<br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-k">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>K</strong>其它</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-k1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-1</strong>关于推荐的浏览器</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        为了安全舒适地使用TRIAM Network，我们建议使用以下版本的浏览器。<br/>
                                                        ・Google（谷歌）最新版本 <br/>
                                                        ・火狐浏览器 最新版本 <br/><br/>
                                                        ※我们不建议使用IE浏览器
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-2</strong>什么是代币？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                        这是TRIAM平台上创建独的加密币。持有TRIAM账户的用户可进行发行申请ISSUER者、只需获得批准，均可发行代币。<br />
                                                        ISSUER者的申请无需费用。发行独创的代币需要RIA币。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-3</strong>删除多余的电子钱包。</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    已创建的电子钱包无法删除。<br />
                                                    但是，多余的电子钱包可以通过电子钱包合并的功能进行账户内的钱包进行管理。<br />
                                                    电子钱包合并功能可使两个电子钱包合并集成一个电子钱包。电子钱包一旦合并，被吸收的电子钱包余量自动清零并删除。电子钱包吸收另外一个电子钱包集成合并操作必须满足一次啊条件<br />
                                                    ・不是作为发行代币用的电子钱包<br/>
                                                    ・不是作为代理店结算的电子钱包<br/>
                                                    ・不是作为交易中的电子钱包 包括 （i接收/发送 货币·代币）<br/>
                                                    ・为TRUST过RIA币以外的货币·代币<br/>
                                                    ・RIA币余量必须20.001以上的电子钱包<br/><br/>
                                                    电子钱包的合并，从我的电子钱包页面中点击「合并电子钱包」进行操作。

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-4</strong>频繁发送货币的电子钱包的地址可以保存吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    可以的。从我的电子钱包页面点击「电子钱包接收方管理」进行保存电子钱包地址。<br/>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-5</strong>电子钱包合并是一项是什么样的功能？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    可将同个账户内的两个电子钱包合并成一个电子钱包。<br />
                                                    电子钱包合并功能可使两个电子钱包合并集成一个电子钱包。电子钱包一旦合并，被吸收的电子钱包余量自动清零并删除。电子钱包吸收另外一个电子钱包集成合并操作必须满足一次啊条件 <br/>
                                                    ・不是作为发行代币用的电子钱包
                                                    ・不是作为代理店结算的电子钱包
                                                    ・不是作为交易中的电子钱包 包括 （i接收/发送 货币·代币）
                                                    ・为TRUST过RIA币以外的货币·代币
                                                    ・RIA币余量必须20.001以上的电子钱包
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k6">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k6" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-6</strong>个人身份确认的相片超过2MB无法上传。应该怎么操作？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k6" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    很抱歉，麻烦使用相片编辑软件或应用，进行相片调整至2MB以内再进行上传。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k7">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k7" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-7</strong>关于电子钱包交易记录查询</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k7" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    各电子钱包的交易记录可从电子钱包交易记录中查询。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-k8">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-k8" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>K-8</strong>设置页面显示的「登录时请输入双重身份验证码 」要求，是什么意思？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-k8" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    我们强烈推荐您打开设置并点击选择栏目的（安全）选项。「要求登录时输入双重验证」前面打勾选择来提高警惕性。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="r-role-item" id="role-m">
                                        <div className="r-role-title">
                                            <h3 className="custom-h3-font-size"><strong>M</strong>Multisign 电子钱包</h3>
                                        </div>
                                        <div className="r-role-item-child" id="role-m1">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-m1" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>M-1</strong>什么是Multisig 电子钱包？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-m1" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    Multisig 电子钱包与普通的电子钱包不同，需要多个密钥使用，进行交易时<br/>
                                                    Multisig电子钱包需要多个密钥进行验证。<br/>
                                                    普通电子钱包的密钥只有一个密钥。万一电脑或手机遭到病毒入侵或在线保存的密<br/>
                                                    码或密钥遭黑客被盗，会造成货币损失的风险。<br/>

                                                    TRIAM的Multisig 电子钱包,一个电子钱包对应3密钥、即使被泄露一个密码也可起到<br/>
                                                    防盗效果。多个密钥被认为可倍数增加安全性。<br/>

                                                    如果使用Multisig电子钱包进行使用 发送 货币·代币 每发送一次必须输入3个密钥。
                                                    </p>
                                                    <p className="red">
                                                    ！！！请注意！！！<br/>

                                                    ·普通电子钱包一旦设为Multisig 电子钱包,则无法取消也无法再返回普通电子钱包。<br/>

                                                    ·普通钱包一旦创建为Multisig 电子钱包，该电子钱包将无法再创建为Shared 电子钱<br/>
                                                    包和设置Master key。一旦设置了Master key的Shared 电子钱包同样无法再创建为Multisig电子钱包。<br/>


                                                    ·TRIAM的Multisig 电子钱包进行发送货币或TRUST代币时每次必须输入3个密钥的操
                                                    作。如果3个密钥的其中一个密钥遗失，该Multisig 电子钱包将永久被冻结无法使用。
                                                    3个密钥在创建Multisig 电子钱包时仅显示1次，无法再次显示也无法再发行，请务必
                                                    妥善保管好。<br/>

                                                    创建Multisig 电子钱包前，请细读以上内容与考虑各种要素后再进行操作。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-m2">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-m2" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>M-2</strong>创建Multisig 电子钱包收费吗？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-m2" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    创建Multisig 电子钱包时，将收取0.003RIA币作为费用
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-m3">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-m3" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>M-3</strong>请教我Multisig 电子钱包创建的步骤</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-m3" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    创建Multisig 电子钱包的设置步骤。<br/>
                                                    （1）登录账户，点击我的电子钱包中的「Multisig 」开始设置。<br/>

                                                    （2）点击「创建Multisig电子钱包」选择想创建成Multisig的电子钱包。<br/>

                                                    （3）下一页面将生成3个相对应Multisig电子钱包的密钥，点击「生成KEY PAIRS」将自动生成KEY PAIRS并自动下载至终端。(因手机终端而异，也有可能存在无法下载的情况。请务必检查终端是否已下载KEY PAIRS） 
                                                    包括此时已生成的3个KEY PAIRS，在今后使用Multisig 电子钱包进行发送货币或代币时，必须使用重要密钥对。请务必确认内容后对密钥进行妥善保管。<br/>

                                                    (4)请在显示3个KEY PAIRS页面的下方显示「Key pairs一旦丢失，电子钱包内的货币/代币则无法转移。请知悉并理解。」的复选框中打勾后点击「下一步」完成Multisig 电子钱包。<br/><br/>


                                                    ※设置Multisig 电子钱包的注意点<br/>
                                                    请注意！设置为Multisig 的电子钱包仅限于通常的电子钱包。Shared 电子钱包的<br/>
                                                    Master key wallet或Signer walle，或者已创建代币的的电子钱包都无法设置为Multisig 电子钱包。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-m4">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-m4" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>M-4</strong>使用 Multisig 电子钱包发送代币的步骤如何操作？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-m4" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    使用 Multisig 电子钱包发送代币的步骤<br/>

                                                    （1）请打开首页菜单中的「Multisig wallet」。<br/>

                                                    （2）选择电子钱包，点击电子钱包内想进行发送的代币。<br/>

                                                    （3）点击「发送货币·代币」。<br/>

                                                    （4）输入接收方的电子钱包地址和发送的数量。<br/>

                                                    （5）点击「发送」按钮，将弹出密钥验证输入文字框，并分别输入所属Multisig电子钱包的3额密钥后点击「确认」按键。<br/>

                                                    （6）最后输入双重身份验证代码后则完成发送。<br/>
                                                    </p>
                                                    <p className="red">
                                                    ！！！请注意！！！<br/>
                                                    TRIAM的Multisig 电子钱包每一次的代币发送都必须输入3个密钥。如果3个密钥其中任何1个密钥被丢失，该Multisig 电子钱包将永久无法使用。<br/>
                                                    由于所属的3个密钥在设置为Multisig 电子钱包时仅显示1次，无法显示第2次也无法再次发行。请务必请务必对密钥进行妥善保管。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r-role-item-child" id="role-m5">
                                            <div className="r-role-title">
                                                <h3 data-toggle="collapse" data-parent="#accordion" href="#c_role-m5" className="panel-title expand custom-h3-font-size">
                                                    <div className="right-arrow pull-right show-content">+</div>
                                                    <a><strong>M-5</strong>安装Multisig电子钱包时下载的密钥确认后，密钥显示为6个，哪个才是密钥？</a>
                                                </h3>
                                            </div>
                                            <div id="c_role-m5" className="panel-collapse collapse ">
                                                <div className="r-role-content">
                                                    <p>
                                                    Multisig电子钱包的3个密钥，在生成KEY PAIRS下载后文件中显示右边的为密钥。为了方便系统，左边的「PUBLIC KEY」和右边显示是为一对的。请注意，如果发送代币等或进行交易时如果输入「PUBLIC KEY」将显示错误无法批准。
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FaqCh;



// WEBPACK FOOTER //
// ./src/containers/faq-ch.jsx